import React from 'react';
import {Outlet, Route, Routes} from "react-router-dom";
import {Home} from "./home/Home";
import Dashboard from "./dashboard/Dashboard";
import Login from "./login/Login";
import {RequireAuth} from "./auth/RequireAuth";
import {Users} from "./users/Users";
import {User} from "./users/User";
import {BotsList} from "./bots/BotsList";
import {BotsActions} from "./bots/BotsActions";
import {ProxiesList} from "./proxies/ProxiesList";
import {Bot} from "./bots/Bot";
import {GamesTabsPage} from "./games/GamesTabsPage";
import {Orders} from "./orders/Orders";
import {Order} from "./orders/Order";
import {Bids} from "./bids/Bids";
import { System } from "./system/System";
import {BannersList} from "./banners/BannersList";
import {Finances} from "./finances/Finances";
import {PaymentMethodEditor} from "./finances/paymentMethods/PaymentMethodEditor";
import {ServerSettingsList} from "./serverSettings/ServerSettingsList";
import { CommissionRulesList } from './commissionRules/CommissionRulesList';
import { UserBlocksPage } from './userBlocks/UserBlocksPage';
import { AccessBlacklistPage } from './accessBlacklist/AccessBlacklistPage';
import { UnitEconomics } from './unitEconomics/UnitEconomics';
import { AdCampaignsList } from './adCampaigns/AdCampaignsList';
import { AdCampaignEditor } from './adCampaigns/AdCampaignEditor';
import { ExternalMarkets } from './externalMarkets/ExternalMarkets';
import { ExternalMarketAnalytics } from './externalMarkets/analytics/ExternalMarketAnalytics';

function AuthRouts() {
    return (
        <Routes>
            <Route path="/" element={<Outlet/>}>
                <Route index element={<Login/>}/>
                <Route path="login" element={<Login/>}/>
                <Route path="app/" element={<RequireAuth/>}>
                    <Route element={<Home/>}>
                        <Route index element={<Dashboard/>}/>
                        <Route path="users">
                            <Route path="" element={<Users/>}/>
                            <Route path=":id" element={<User/>}/>
                        </Route>
                        <Route path="proxies" element={<ProxiesList/>}/>
                        <Route path="games" element={<GamesTabsPage/>}/>
                        <Route path="bots">
                            <Route path="" element={<BotsList/>}/>
                            <Route path=":id" element={<Bot/>}/>
                        </Route>
                        <Route path="bots-actions" element={<BotsActions/>}/>
                        <Route path="orders">
                            <Route path="" element={<Orders/>}/>
                            <Route path=":id" element={<Order/>}/>
                        </Route>
                        <Route path="bids" element={<Bids/>}/>
                        <Route path="system" element={<System/>}/>
                        <Route path="banners" element={<BannersList/>}/>
                        <Route path="payment-methods" element={<Finances/>}/>
                        <Route path="payment-methods/new" element={<PaymentMethodEditor/>}/>
                        <Route path="payment-methods/:id/edit" element={<PaymentMethodEditor/>}/>
                        <Route path="settings" element={<ServerSettingsList/>}/>
                        <Route path="commissionRules" element={<CommissionRulesList/>}/>
                        <Route path="user-blocks" element={<UserBlocksPage/>}/>
                        <Route path="access-blacklist" element={<AccessBlacklistPage/>}/>
                        <Route path="unit-economics" element={<UnitEconomics/>}/>
                        <Route path="ad-campaigns" element={<AdCampaignsList/>}/>
                        <Route path="ad-campaigns/new" element={<AdCampaignEditor/>}/>
                        <Route path="ad-campaigns/:id/edit" element={<AdCampaignEditor/>}/>
                        <Route path="external-markets" element={<ExternalMarkets/>}/>
                        <Route path="external-markets/analytics" element={<ExternalMarketAnalytics/>}/>
                    </Route>
                </Route>
            </Route>
        </Routes>
    );
}

export default AuthRouts;
